export const POPOVER_OFFSET_ANCHOR = 40; // px
export enum PopoverDir {
  TOP = 'top',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  LEFT = 'left',
}
